import './styles/index.less';
import 'typeface-lato';

import { HelmetProvider } from 'react-helmet-async'; // eslint-disable-line

import Routing from './routing';
import { useState } from 'react';

function App() {
  const isDarkTheme = false;
  const [darkMode, setDarkMode] = useState(isDarkTheme);
  return (
    <HelmetProvider>
      <Routing darkMode={darkMode} setDarkMode={setDarkMode}></Routing>
    </HelmetProvider>
  );
}

export default App;
